import { ff } from '@atlassian/jira-feature-flagging';

export const isCompassComponentsInJiraComponentsEnabled = () =>
	ff('compass-components-in-jira-components_xw42u');
